import { render, staticRenderFns } from "./BulkMemberTagForm.vue?vue&type=template&id=2d8292fb&scoped=true"
import script from "./BulkMemberTagForm.vue?vue&type=script&lang=js"
export * from "./BulkMemberTagForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8292fb",
  null
  
)

export default component.exports